(() => {
  const initGuide = (templateId, drawerId, triggerSelector) => {
    const template = document.getElementById(templateId);
    if (!template) return;
    document.body.append(template.content.cloneNode(true));
    const drawer = document.getElementById(drawerId);
    let opener;
    let closing = false;
    let closeTimer;
    const close = () => {
      if (!drawer.open || closing) return;
      closing = true;
      drawer.classList.remove('is-visible');
      closeTimer = setTimeout(() => drawer.close(), 220);
    };
    drawer.addEventListener('close', () => {
      clearTimeout(closeTimer);
      closing = false;
      document.documentElement.classList.remove('goose-size-guide-open');
      opener?.setAttribute('aria-expanded', 'false');
      opener?.focus({ preventScroll: true });
    });
    drawer.addEventListener('cancel', (event) => {
      event.preventDefault();
      close();
    });
    drawer.addEventListener('click', (event) => {
      if (event.target.closest('[data-size-guide-close]')) close();
      if (event.target === drawer) {
        const bounds = drawer.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right ||
            event.clientY < bounds.top || event.clientY > bounds.bottom) close();
      }
    });
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest(triggerSelector);
      if (!trigger) return;
      event.preventDefault();
      opener = trigger;
      const sourceDetails = trigger.closest('details');
      if (sourceDetails) sourceDetails.open = false;
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', drawer.id);
      trigger.setAttribute('aria-expanded', 'true');
      if (drawer.open) return;
      document.documentElement.classList.add('goose-size-guide-open');
      drawer.showModal();
      drawer.querySelector('[data-size-guide-close]').focus();
      requestAnimationFrame(() => requestAnimationFrame(() => drawer.classList.add('is-visible')));
    });
  };
  initGuide('GooseSizeGuideTemplate', 'GooseSizeGuide', '[data-goose-size-guide-open], details[id^="Details-collapsible_tab_VfTimn-"] > summary');
  initGuide('GooseMaterialGuideTemplate', 'GooseMaterialGuide', '[data-goose-material-guide-open], details[id^="Details-collapsible_tab_JVxDMn-"] > summary');
  initGuide('GooseBeaverWaitlistTemplate', 'GooseBeaverWaitlist', '[data-goose-beaver-waitlist-open]');
})();
